var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.value,"placeholder":"Select"}},[_c('el-option',{attrs:{"label":"Español (Colombia)","value":"es-CO"}}),_c('el-option',{attrs:{"label":"English (United States)","value":"en-US"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }